// เมนูหลัก — ใช้ร่วมกันทั้ง sidebar (desktop) และ bottom nav (mobile)
export const SIDEBAR_NAV = [
  { to: "/", label: "หน้าแรก", icon: "home", end: true },
  { to: "/search", label: "ค้นหา", icon: "search" },
  { to: "/chat", label: "แชท", icon: "chat" },
  { to: "/create", label: "สร้างตัวละคร", icon: "plus" },
  { to: "/feed", label: "ฟีดโซเชียล", icon: "feed" },
  { to: "/shorts", label: "คลิปสั้น", icon: "play" },
  { to: "/ranking", label: "จัดอันดับ", icon: "trophy" },
];
export const SIDEBAR_NAV_2 = [
  { to: "/rewards", label: "รางวัล & เช็คอิน", icon: "gift" },
  { to: "/coins", label: "เติมคอยน์", icon: "coin" },
  { to: "/club", label: "คลับ VIP", icon: "crown" },
  { to: "/me", label: "โปรไฟล์ของฉัน", icon: "user" },
  { to: "/settings", label: "ตั้งค่า", icon: "settings" },
];
export const BOTTOM_NAV = [
  { to: "/", label: "หน้าแรก", icon: "home", match: (p) => p === "/" || p.startsWith("/c/") || p.startsWith("/universe") || p.startsWith("/creator") || p.startsWith("/ranking") },
  { to: "/search", label: "ค้นหา", icon: "search", match: (p) => p.startsWith("/search") },
  { to: "/create", label: "สร้าง", icon: "plus", match: (p) => p.startsWith("/create") },
  { to: "/chat", label: "แชท", icon: "chat", match: (p) => p.startsWith("/chat") },
  { to: "/me", label: "ฉัน", icon: "user", match: (p) => p.startsWith("/me") || p.startsWith("/settings") || p.startsWith("/coins") || p.startsWith("/club") || p.startsWith("/rewards") || p.startsWith("/notifications") },
];
